export default{
  login: (state) => state.login
}



// WEBPACK FOOTER //
// ./src/components/bank/store/getters.js